import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResellerService } from '../../../core/services/reseller.service';
import { LoggedUserInfo, Multiselect, MultiselectItem, MultiselectSettings } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { CommonService } from '../../services/common.service';
import { CodeRole } from '../../../core/interfaces/user.interface';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-user-reseller-select',
  templateUrl: './user-reseller-select.component.html',
  styleUrls: ['./user-reseller-select.component.scss']
})
export class UserResellerSelectComponent {

  @Input() resellerSelected: MultiselectItem[] = [];
  @Input() singleSelection: boolean = null;

  @Output() resellerSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  loggedUserInfo: LoggedUserInfo;

  CodeRole = CodeRole;

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    const base = MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH];
    if (this.singleSelection != null) {
      return { ...base, singleSelection: !!this.singleSelection };
    }
    return base;
  }

  resellerList: MultiselectItem[] = [];

  constructor(
    public resellerService: ResellerService,
    public portalService: PortalService,
    public commonService: CommonService,
  ) {
    this.loggedUserInfo = this.commonService.getLoggedUserInfo();
    this.load();
  }

  onResellerSelect(): void {
    this.resellerSelectedChange.emit(this.resellerSelected);
    this.onSelected.emit(this.resellerSelected);
  }

  load() {

    let $api;

    if (this.loggedUserInfo.role == CodeRole.SUPERADMIN) {
      $api = this.portalService.getMultiselectItems(Multiselect.RESELLER_IS_COMPANY);
    } else if (this.loggedUserInfo.role == CodeRole.COMPANY_ADMIN) {
      $api = this.resellerService.getUserMyReseller()
    } else {
      return;
    }

    $api.subscribe((response) => {

      this.resellerList = response?.data.map(reseller => {

        return {
          id: reseller.id,
          itemName: reseller.name
        } as MultiselectItem

      })

    },
    (error) => {
      console.log("errore", error);
    });

  }

}
